// 通用接口
import { $request } from '@/utils/request'



//上传图片
export const upload = (data, config) => $request('/Upload/upload', data, config, 'POST')
//获取用户缓存数据
export const authType = (data, config) => $request('/User/authType', data, config, 'GET')
//授权登录
export const authLogin = (data, config) => $request('/User/authLogin', data, config, 'GET')
//授权绑定手机号
export const authBindingPhone = (data, config) => $request('/User/authBindingPhone', data, config, 'POST')
//退出登录
export const Userlogout = (data, config) => $request('/User/logout', data, config, 'POST')
//登录
export const login = (data, config) => $request('/User/mobileLogin', data, config, 'POST')
//发送验证码
export const sendCode = (data, config) => $request('/User/sendCode', data, config, 'POST')

//pc获取验证码
export const BaseSendSms = (data, config) => $request('/Base/sendSms', data, config, 'POST')

//设置身份
export const setUserType = (data, config) => $request('/User/setUserType', data, config, 'POST')

//字典
export const dictValue = (data,config) => $request(`/Base/dictValue`, data, config, 'GET')
//个人信息
export const personal = (data,config) => $request(`/User/personal`, data, config, 'GET')
//需求列表
export const DemandIndex = (data,config) => $request(`/Demand/index`, data, config, 'GET')
//发布需求
export const DemandAdd = (data,config) => $request(`/Demand/add`, data, config, 'POST')
//需求详情
export const DemandDetail = (d_id,data,config) => $request(`/Demand/detail/${d_id}`, data, config, 'GET')
//提交意见反馈
export const FeedbackAdd = (data,config) => $request(`/Feedback/add`, data, config, 'POST')
//反馈意见列表
export const FeedbackIndex = (data,config) => $request(`/Feedback/index`, data, config, 'GET')
//邀请好友列表
export const inviteList = (data,config) => $request(`/User/inviteList`, data, config, 'GET')
//资金明细
export const billList = (data,config) => $request(`/User/billList`, data, config, 'GET')
//邀请服务方列表
export const UserCooperate = (data,config) => $request(`/UserCooperate/index`, data, config, 'GET')
//确认邀标
export const DemandInviteAdd = (data,config) => $request(`/DemandInvite/add`, data, config, 'POST')
//报价列表
export const QuoteIndex = (data,config) => $request(`/Quote/index`, data, config, 'GET')
//我的邀标列表
export const DemandInviteIndex = (data,config) => $request(`/DemandInvite/index`, data, config, 'GET')
//完善服务方数据
export const setIdentity = (data,config) => $request(`/User/setIdentity`, data, config, 'POST')
//报价
export const QuoteAdd = (data,config) => $request(`/Quote/add`, data, config, 'POST')
//评审员评审列表
export const OrderReviewUser = (data,config) => $request(`/OrderReviewUser/index`, data, config, 'GET')
//评审员评审详情
export const OrderReviewUserDetail = (oruId,data,config) => $request(`/OrderReviewUser/detail/${oruId}`, data, config, 'GET')
//评审
export const OrderReviewUserJudge = (oruId,data,config) => $request(`/OrderReviewUser/judge/${oruId}`, data, config, 'POST')
//订单列表
export const OrderIndex = (data,config) => $request(`/Order/index`, data, config, 'GET')
//选标
export const chooseQuote = (d_id,data,config) => $request(`/Demand/chooseQuote/${d_id}`, data, config, 'POST')
//订单收藏/取消收藏
export const CollectOId = (oId,data,config) => $request(`/Order/collect/${oId}`, data, config, 'POST')
//订单详情
export const OrderDetail = (o_id,data,config) => $request(`/Order/detail/${o_id}`, data, config, 'GET')
//订单支付
export const OrderPay = (data,config) => $request(`/Order/pay`, data, config, 'POST')
//服务方上传订单附件
export const OrderStageUpload = (data,config) => $request(`/OrderStage/upload`, data, config, 'POST')
//查看订单附件
export const OrderFiles = (oId,data,config) => $request(`/Order/files/${oId}`, data, config, 'GET')
//确认验收
export const OrderStageConfirm = (osId,data,config) => $request(`/OrderStage/confirm/${osId}`, data, config, 'POST')
//评价
export const OrderRating = (oId,data,config) => $request(`/Order/rating/${oId}`, data, config, 'POST')
//发票列表
export const InvoiceIndex = (data,config) => $request(`/Invoice/index`, data, config, 'GET')
//申请开票 
export const InvoiceApply = (oId,data,config) => $request(`/Invoice/apply/${oId}`, data, config, 'POST')
//拒绝邀标
export const rejectDi_id = (di_id,data,config) => $request(`/DemandInvite/reject/${di_id}`, data, config, 'POST')
//需求方发起评审
export const OrderReviewApply = (osId,data,config) => $request(`/OrderReview/apply/${osId}`, data, config, 'POST')
//评审支付
export const OrderReviewPay= (data,config) => $request(`/OrderReview/pay`, data, config, 'POST')
//需求评审详情
export const OrderReviewDetail = (orId,data,config) => $request(`/OrderReview/detail/${orId}`, data, config, 'GET')
//服务方申辩提交
export const defenseOrId = (orId,data,config) => $request(`/OrderReview/defense/${orId}`, data, config, 'POST')
// 更新数据
export const UserUpdate = (data,config) => $request(`/User/update`, data, config, 'POST')
//留言列表
export const OrderMessagelist = (o_id,data,config) => $request(`/OrderMessage/index/${o_id}`, data, config, 'GET')
//站内信列表
export const MessageIndex = (data,config) => $request(`/Message/index`, data, config, 'GET')
//添加留言
export const OrderMessageAdd = (data,config) => $request(`/OrderMessage/add`, data, config, 'POST')
//站内信单条已读
export const ReadM_id = (m_id,data,config) => $request(`/Message/read/${m_id}`, data, config, 'POST')
//修改需求
export const Demandupdate = (data,config) => $request(`/Demand/update`, data, config, 'POST')
//提现记录明细
export const WithdrawIndex = (data,config) => $request(`/Withdraw/index`, data, config, 'GET')
//获取配置
export const BaseGetConfig = (data,config) => $request(`/Base/getConfig`, data, config, 'GET')
//提现
export const WithdrawApply = (data,config) => $request(`/Withdraw/apply`, data, config, 'POST')
//零钱提现失败
export const CancelWId = (wId,data,config) => $request(`/Withdraw/cancel/${wId}`, data, config, 'POST')
//轮播图
export const banner = (data,config) => $request(`/Base/banner/2`, data, config, 'GET')
//获取协议
export const getProtocal = (data,config) => $request(`/Base/getProtocal`, data, config, 'GET')
//获取订单应付评审金额
export const priceosId = (osId,data,config) => $request(`/OrderReview/price/${osId}`, data, config, 'GET')
//订单评审详情
export const detailByOrder = (oId,data,config) => $request(`/OrderReview/detailByOrder/${oId}`, data, config, 'GET')
//站内信全部已读
export const readAll = (data,config) => $request(`/Message/readAll`, data, config, 'POST')
//获取开票金额
export const invoicePrice = (oId,data,config) => $request(`/Order/invoicePrice/${oId}`, data, config, 'GET')
//轮训chaxun
export const payStatus = (data,config) => $request(`/Order/payStatus`, data, config, 'GET')
